import { getInteractionType } from 'models/interaction_type';

export function sessionTypeForContent(content) {
  return getInteractionType(content.type, content);
}
